var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconlyLightEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.205,
    height: 12.947,
    viewBox: "0 0 13.205 12.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Edit",
    "data-name": "Iconly/Light/Edit",
    transform: "translate(-2.395 -2.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Stroke-1",
    x2: 4.835,
    transform: "translate(7.165 11.629)",
    fill: "none",
    stroke: "#0056ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-3",
    d: "M6.52.53A1.5,1.5,0,0,1,8.6.328l1.156.9a1.428,1.428,0,0,1,.48,1.989c-.023.036-6.358,7.961-6.358,7.961A1.133,1.133,0,0,1,3,11.6l-2.426.03L.029,9.315a1.086,1.086,0,0,1,.211-.93Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#0056ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-5",
    x2: 3.635,
    y2: 2.791,
    transform: "translate(5.347 2.001)",
    fill: "none",
    stroke: "#0056ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyLightEdit);
export default __webpack_public_path__ + "static/media/Iconly-Light-Edit.5640b51db1f5507e116f9e2108250a6b.svg";
export { ForwardRef as ReactComponent };